/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>账号列表
      <div class="ml-auto" slot="right">
        <el-button size="small" type="success" @click="addStaff">添加账号</el-button>
        <el-button size="small" type="primary" @click="getStructure">查看人员架构</el-button>
      </div>
    </public-title>
    <div class="load-area">
      <p v-if="staffLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="Itemize in staffLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col">{{Itemize.truename}}
            <span class="ml-1" :class="Itemize.status ? 'text-success' : 'text-danger'">{{Itemize.status ? '[启用中]':'[禁用中]'}}</span>
          </li>
          <li class="w-50 list-item-col">{{Itemize.mobile}}</li>
          <li class="w-50 list-item-col" :class="[Itemize.wechat_openid ?'text-success':'text-danger']">
            {{Itemize.wechat_openid ? '已绑定':'未绑定'}}
          </li>
          <li class="w-50 list-item-col">{{Itemize.name}}</li>
          <li class="w-50 list-item-col">
            {{Itemize.num}}
            <el-tooltip class="ml-1" effect="dark"  placement="right" v-show="Itemize.login_time">
              <div slot="content">上次登录时间：{{Itemize.login_time | formatTimestamp(1)}}</div>
              <i class="el-icon-info"></i>
            </el-tooltip>
          </li>
          <li class="w-50 list-item-col d-flex flex-column">
            <span class="text-link" @click="showAccessFun(Itemize)">查看权限</span>
            <span class="text-link mr-2" @click="showStore(Itemize)">查看管理门店</span>
          </li>
          <li class="w-50 list-item-col-end">
            <label v-if="userLoginMessage.uid == Itemize.uid" class="text-warning">自己</label>
            <label v-else>
              <span class="text-link mr-2" @click="editItem(Itemize)">编辑</span>
              <span class="text-link" @click="deleteItem(Itemize)">删除</span>
            </label>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="staffLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => {this.currentPage=v;this.$router.push({name:this.$route.name,query:{page:v}})}"/>
      </div>
    </div>
    <!--账号权限-->
    <el-dialog title="账号权限" :visible.sync="showAccess" center>
      <el-tree :data="powerArr" :props="defaultProps" />
      <el-button type="primary" @click="showAccess = false" slot="footer">确 定</el-button>
    </el-dialog>
    <!--账号管理的门店列表-->
    <el-dialog title="管理门店" :visible.sync="showAccountStore" center>
      <p v-if="accountStore.length<=0">该账号还未关联门店</p>
      <div v-else>
        <p class="mb-2" v-for="item in accountStore" :key="item.title">{{item.title}}
          <span class="ml-2" :class="[item.verify === 1?'text-success':'text-danger']">[{{item.verify | formatVar('verifyType')}}]</span>
        </p>
      </div>
      <el-button type="primary" @click="showAccountStore = false" slot="footer">确 定</el-button>
    </el-dialog>
    <!--人员架构-->
    <account-structure v-show="showStructure" @closePanel="showStructure=false"/>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'
  import AccountStructure from './StaffStructure'

  export default {
    name: 'Lists',
    components: { AccountStructure },
    computed: {
      ...mapState(['staffLists','positionDetail','userLoginMessage']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      powerArr() { return this.positionDetail.power_arr }
    },
    watch:{
      queryCon() { this.getUserStaffLists({...this.queryCon,page:this.currentPage}); },
    },
    data() {
      return {
        titleArr:['姓名','手机号','微信','职位名称','登录次数','查看','操作'],
        currentPage:1,
        showAccess:false,           //展示账号权限
        showAccountStore:false,     //展示账号的门店列表
        showStructure:false,        //展示人员架构
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        accountStore:[],            //账号管理的门店列表
      }
    },
    mounted() {
      if (this.queryCon.hasOwnProperty('page')) this.getUserStaffLists({page:this.queryCon.page});
      else this.getUserStaffLists({page:this.currentPage});
      
    },
    methods:{
      ...mapActions(['getUserStaffLists','deletePosition','getPositionDetail','getStaffStore','getStaffStructure','cancelStaff']),
      //跳转到添加账号
      addStaff() {
        if (!this.$GFUN.powerIsInArray([338,171,294,394,590])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addStaff'})
      },
      //注销账号
      deleteItem(item) {
        if (!this.$GFUN.powerIsInArray([342,180,299,396,588])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('注销后该账号无法再登陆, 是否继续？',() => { this.cancelStaff(item.uid) });
      },
      //跳转到编辑账号
      editItem(item) {
        if (!this.$GFUN.powerIsInArray([340,172,296,395,591])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'editStaff',query:{account:item.uid}});
      },
      //查看账号权限
      showAccessFun(item) {
        if (!this.$GFUN.powerIsInArray([339,298,295,393,587])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.getPositionDetail(item.position_id);
        this.showAccess = true;
      },
      //查看账号管理的门店列表
      async showStore(item) {
        this.accountStore = await this.getStaffStore(item.uid);
        this.showAccountStore  = true;
      },
      //查看人员架构
      getStructure() {
        // if (!this.$GFUN.powerIsInArray([358,359,360,386,580])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.getStaffStructure({tree:1});
        this.showStructure = true;
      }
    },
  }
</script>
